<template>
  <span v-if="countries.length && countries.length > 0">
    <a-tag
      v-for="country in countries"
      :key="`${country.name}`"
    >
      <span
        role="img"
        :aria-label="country.code">{{ country.flag }}</span>
      {{ country.name }}
    </a-tag>
  </span>
  <span v-else>
    {{ 'announcement-detail.lbl-any-country' | globalize }}
  </span>
</template>

<script>

import ATag from 'ant-design-vue/lib/tag'
import 'ant-design-vue/lib/tag/style/index.css'

export default {
  name: 'announcement-countries',
  components: {
    ATag,
  },
  props: {
    countries: {
      type: Array,
      default: () => [],
    },
  },
}
</script>
